export default __webpack_public_path__ + "static/media/18.712b1cda.svg";